import { Component, HostListener } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppService } from '../../core/services/app.service';
import { Router, NavigationEnd, Event as RouterEvent } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ParametrageService } from '../../core/services/parametrage-service/parametrage.service';

@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrl: './main-layout.component.scss'
})
export class MainLayoutComponent {
  store: any;
  showTopButton = false;
  isSidebarCollapsed = false;
  availableYears: any = {};

  constructor(
    public translate: TranslateService,
    public storeData: Store<any>,
    private service: AppService,
    private router: Router,
    private parametrageService: ParametrageService
  ) {
      this.initStore();
  }
  headerClass = '';

  onSidebarCollapse(collapsed: boolean): void {
    this.isSidebarCollapsed = collapsed;
  }

  @HostListener('window:resize')
  onResize() {
    if (window.innerWidth >= 1024 && this.store?.sidebar) {
      this.storeData.dispatch({ type: 'closeSidebar' });
    }
  }
  ngOnInit() {
      this.initAnimation();
      this.toggleLoader();
      this.loadAvailableYears();
      window.addEventListener('scroll', () => {
          if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
              this.showTopButton = true;
          } else {
              this.showTopButton = false;
          }
      });
  }

  ngOnDestroy() {
      window.removeEventListener('scroll', () => {});
  }

  initAnimation() {
      this.service.changeAnimation();
      this.router.events.subscribe((event) => {
          if (event instanceof NavigationEnd) {
              this.service.changeAnimation();
          }
      });

      const ele: any = document.querySelector('.animation');
      ele.addEventListener('animationend', () => {
          this.service.changeAnimation('remove');
      });
  }

  toggleLoader() {
      this.storeData.dispatch({ type: 'toggleMainLoader', payload: true });
      setTimeout(() => {
          this.storeData.dispatch({ type: 'toggleMainLoader', payload: false });
      }, 500);
  }

  async initStore() {
      this.storeData
          .select((d) => d.index)
          .subscribe((d) => {
              this.store = d;
          });
  }

  goToTop() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
  }

  loadAvailableYears() {
      this.parametrageService.getAnneeExistParModule().subscribe({
          next: (response: any) => {
              if (response.success) {
                  this.availableYears = response.data.modules;
                  // Store in localStorage or service for use across components
                  localStorage.setItem('availableYears', JSON.stringify(this.availableYears));
              }
          },
          error: (error) => {
              console.error('Error loading available years:', error);
          }
      });
  }
}
